import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {ErrorComponent} from "./error.component";

const routes: Routes = [
  {
    path: 'error',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: ErrorComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ErrorRoutingModule { }
